import { render } from "./toastrPosition.vue?vue&type=template&id=cc6dc796"
import script from "./toastrPosition.vue?vue&type=script&lang=js"
export * from "./toastrPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__